var _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask__sunset",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 160,
    fill: "#FFFFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask__sunset)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0)",
    d: "M0 0h80v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1)",
    d: "M0 40h80v40H0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1",
    x1: 40,
    y1: 40,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00bcf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bcf5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIcon);
export default __webpack_public_path__ + "static/media/light-icon.0dd6b9878c6e895133c17ced1f266caa.svg";
export { ForwardRef as ReactComponent };